import * as LoginConstants from './login.constants';

export default LoginConstants;
